import { forwardRef } from 'react';
import { Link, LinkProps, useSearchParams } from 'react-router-dom';

/**
 * App-aware Link component that preserves workspace context (?ws=xxx)
 *
 * Use this instead of Link for internal navigation to ensure
 * workspace param is retained across the app.
 *
 * Wrapped with forwardRef to work with Radix UI components (Button asChild, etc.)
 */
export const AppLink = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ to, ...props }, ref) => {
    const [searchParams] = useSearchParams();
    const ws = searchParams.get('ws');

    if (!ws || typeof to !== 'string') {
      return <Link ref={ref} to={to} {...props} />;
    }

    // Preserve workspace param
    const hasQuery = to.includes('?');
    const separator = hasQuery ? '&' : '?';
    const url = `${to}${separator}ws=${ws}`;

    return <Link ref={ref} to={url} {...props} />;
  }
);

AppLink.displayName = 'AppLink';
